import TemplateView from "../../../TemplateView";

export default class MinimizeKanbanViewCardsButton extends TemplateView {

    constructor($containerEl, {onClick = {}}) {
        super($containerEl);

        this.onClick = onClick;

        this.state = {
            minimizedCards: false
        }

        this.onStatePropertyChanged("minimizedCards", (value) => {
            this._setButtonAppearance(value)
        })
    }

    templateHtml() {
        return "<div class='minimizeButtonContainer'>" +
               "  <div class='buttonIcon'></div>"+
               "  <div class='buttonText'></div>" +
               "</div>"
    }

    afterRender() {
        this.$el.on("click", this.onClick)
        this._setButtonAppearance(this.state.minimizedCards)
    }

    _setButtonAppearance(minimizedCards) {
        this.$el.toggleClass("minimizeButton", !minimizedCards);
        this.$el.toggleClass("extendButton", minimizedCards);

        const minimizeButtonText = this.find(".buttonText");

        if (minimizedCards) {
            minimizeButtonText.text("Extend cards")
        } else {
            minimizeButtonText.text("Minimize cards")
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/MinimizeKanbanViewCardsButton.js